export default "<router-outlet></router-outlet>\r\n<!--<app-my-loader></app-my-loader>-->\r\n"